import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canUseAgentArea } from './AgentRoute';
import { NEW_PROPERTY_PATH } from '../agent/workspace/paths';

/**
 * NewPropertyRoute - "Add a property" at the seller's URL (/my-property/new, pages/AddPropertyPage).
 * An agent adds a home as a listing at their own URL (/agent/properties/new), with the same query
 * (an outreach code, a step); everyone else gets the page.
 */
const NewPropertyRoute = ({ children }) => {
  const location = useLocation();
  const { currentUser } = useAuth();
  if (canUseAgentArea(currentUser)) {
    return <Navigate to={`${NEW_PROPERTY_PATH}${location.search}`} replace />;
  }
  return children;
};

export default NewPropertyRoute;
